var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { class: { "form-group": true, "form-group-lg": _vm.lg } }, [
        _c(
          "label",
          {
            class: {
              "col-xs-12": !_vm.block,
              "col-md-3": !_vm.block,
              "control-label": _vm.block,
            },
          },
          [_vm._v(_vm._s(_vm.$t("search.parallel.searchSourceVersion")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: { "col-xs-12": !_vm.block, "col-md-9": !_vm.block } },
          [
            _c("SelectPicker", {
              attrs: {
                options: _vm.pSourceOptions,
                "data-menu-width": "grow",
                hideEmpty: "",
              },
              model: {
                value: _vm.pSourceValue,
                callback: function ($$v) {
                  _vm.pSourceValue = $$v
                },
                expression: "pSourceValue",
              },
            }),
            _vm._v(" "),
            _c("transition", { attrs: { name: "flash" } }, [
              _vm.errorNoParallelSourceVersion
                ? _c("span", { staticClass: "error" }, [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("search.parallel.errorNoSourceVersion")) +
                        "\n\t\t\t\t"
                    ),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { class: { "form-group": true, "form-group-lg": _vm.lg } }, [
        _c(
          "label",
          {
            class: {
              "col-xs-12": !_vm.block,
              "col-md-3": !_vm.block,
              "control-label": _vm.block,
            },
          },
          [
            _vm._v(
              _vm._s(_vm.$t("search.parallel.andCompareWithTargetVersions"))
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { class: { "col-xs-12": !_vm.block, "col-md-9": !_vm.block } },
          [
            _c("MultiValuePicker", {
              attrs: { options: _vm.pTargetOptionsWithCurrent },
              model: {
                value: _vm.pTargetValue,
                callback: function ($$v) {
                  _vm.pTargetValue = $$v
                },
                expression: "pTargetValue",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("AlignBy", { attrs: { block: _vm.block, lg: _vm.lg } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }